import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import { useDataFetcherV2 } from 'components/Common/Data/useDataFetcher';
import PayWallDialogWrapper from 'components/PayWall/PayWallDialogWrapper';
import { openPayWallForFeature } from 'components/PayWall/Redux/Actions';
import { track } from 'components/Services/Analytics/AnalyticsService';
import { fetchBillingPlanFeatures } from './data';
import { VEHICLE_GPS_TRRACKING } from '../AppsData';
import PendingMigrationBanner from './PendingMigrationBanner';
import PendingDowngradeMessage from './PendingDowngradeMessage';

const MojioButton = () => {
  const appConfiguration = useSelector((state) => state.appConfiguration);
  const dispatch = useDispatch();
  const handleUpgrade = () => {
    dispatch(track('Click', {
      button_name: 'upgrade',
      app_name: 'vehicle_gps_tracking',
      pathname: '/pro/apps/details/vehicle_gps_tracking',
    }));

    dispatch(openPayWallForFeature(VEHICLE_GPS_TRRACKING, () => window.location.reload()));
  };
  const handleTellMeMore = () => {
    dispatch(track('Click', {
      button_name: 'tell me more',
      app_name: 'vehicle_gps_tracking',
      pathname: '/pro/apps/details/vehicle_gps_tracking',
    }));

    Intercom('showNewMessage', 'Can you tell me more about Vehicle GPS Tracking?');
  };

  const [loadedFeatures, features] = useDataFetcherV2(fetchBillingPlanFeatures);

  if (!loadedFeatures) {
    return null;
  }

  const feature = features.filter((f) => f.name === 'vehicle_tracking').pop();

  const pending = appConfiguration.vehicles_pending;
  const tracked = appConfiguration.vehicles_tracked;

  const isProcessingUpgrade = () => (
    appConfiguration.ready && feature.quantity && tracked !== feature.quantity && pending !== feature.quantity
  );

  const isPendingApproval = () => (
    !appConfiguration.ready && appConfiguration.state === 'pending_migration_approval'
  );

  const isPendingDowngrade = () => (
    appConfiguration.ready && appConfiguration.state === 'pending_downgrade'
  );

  if (!feature) {
    return (
      <>
        <Button color="primary" variant="contained" onClick={handleUpgrade}>
          Upgrade
        </Button>
        {' '}
        <Button color="primary" variant="outlined" onClick={handleTellMeMore}>
          Tell me more
        </Button>
        <PayWallDialogWrapper />
      </>
    );
  }

  if (isProcessingUpgrade()) {
    setTimeout(() => window.location.reload(), 10000);

    return (
      <Typography>
        Processing your upgrade... please hang tight. This page will auto-refresh every 10 seconds.
      </Typography>
    );
  }

  if (appConfiguration.error) {
    return (
      <Typography>
        An error occurred while creating your account.
        {' '}
        Please report it on the
        {' '}
        <a href="https://help.housecallpro.com/en/articles/3557902-using-the-blue-chat-bubble" target="_blank" rel="noreferrer noopener">
          Blue Chat Bubble
        </a>
        :
        {' '}
        {appConfiguration.error}
      </Typography>
    );
  }

  if (!appConfiguration.state) {
    setTimeout(() => window.location.reload(), 10000);

    return (
      <Typography>
        Processing your upgrade... please hang tight. This page will auto-refresh every 10 seconds.
      </Typography>
    );
  }

  if (appConfiguration.state === 'creation') {
    setTimeout(() => window.location.reload(), 10000);

    return (
      <Typography>
        We are still processing your purchase and creating your account...
        {' '}
        please hang tight. This page will auto-refresh every 10 seconds.
      </Typography>
    );
  }

  if(isPendingApproval()){
    return (
      <PendingMigrationBanner />
    );
  }

  if(isPendingDowngrade()){
    return (
      <PendingDowngradeMessage />
    );
  }

  return null;
};

export default MojioButton;
